export default __webpack_public_path__ + "static/media/generative-ai-essentials-for-data-analytics.d011825e.png";